import React, {Component} from 'react';

import queryString from 'query-string';

import List from './list.js';


class TomoplayChild extends Component {


	constructor(props) {
		super(props);

		this.state= {
			view : this.props.view,
			query : this.props.query
		};

	}

	render() {
		if(this.state.view === 'list') {
			return (
				<div className="container-fluid dashboard-content">
	            	<div className="row">
	            		<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
	                    	<List page={this.state.query.page} status={this.state.query.status} keyword={this.state.query.keyword} type={this.state.query.type}/>
                		</div>
	            	</div>
	            </div>
			)	
		} else if (this.state.view === 'detail') {
			return (
				<div className="dashboard-wrapper">
	                <div className="dashboard-ecommerce">
	                    <div className="container-fluid dashboard-content ">
	                    	
	                    </div>
	                </div>
	            </div>	
				
			)	
		} 
		
	}


}


export default TomoplayChild;